import { Injectable } from '@angular/core';
import { HttpClient, HttpParams , HttpHeaders, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { HttpContext } from '@angular/common/http';
import { SKIP_LOADER } from './tokens/skip-loader.token';
@Injectable({
  providedIn: 'root'
})
export class ApiService {
  hostURL = environment.apiUrl;
  centralDomain=environment.centralApi;
  constructor(private http: HttpClient) { }

  //statement

  getData(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key]) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
    return this.http.get<any>(`${this.hostURL}/statements`, { params: httpParams });
  }
  getStatementsById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/statements/${id}`);
  }
  saveStatement(name: string, description: any, top_heading: string, bottom_heading:string, opening_balance: number,statement_type:string): Observable<any> {
    const payload = JSON.stringify({ name, description, top_heading, bottom_heading,  opening_balance,statement_type });
    return this.http.post(`${this.hostURL}/statements`, payload, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  deleteStatement(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/statements/${id}`);
  }
  updateStatement(id: number, statement: string, description: string, top_heading: string, bottom_heading: string, opening_balance: number,statement_type:string): Observable<any> {
    const updateUrl = `${this.hostURL}/statements/${id}`;

    return this.http.put(updateUrl, { name: statement, description, top_heading, bottom_heading, opening_balance,statement_type });
  }

  //group

  getAllGroupsAndMaps(selectedStatementType: string,branch_id:string): Observable<any> {
    const url = `${this.hostURL}/groups`;
    const params = new HttpParams()
      .set('statement_id', selectedStatementType)
      .set('branch_id', branch_id);
    return this.http.get<any>(url, { params });
  }

  getgroupData(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key]) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
    return this.http.get<any>(`${this.hostURL}/groups`, { params: httpParams });
  }

  saveGroup(payload: any): Observable<any> {
    return this.http.post(`${this.hostURL}/groups`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  deleteGroup(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/groups/${id}`);
  }
  updateGroup(id: number, postData: any): Observable<any> {
    const updateUrl = `${this.hostURL}/groups/${id}`;
    return this.http.put(updateUrl, postData);
  }
  getGroupsById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/groups/${id}`);
  }

  //ledger
  getDataLedger(params?:any, page: number = 1, size: number = 10000000,offset?: number,sorting?: string, searchTerm?: string,page_name?: string,fetchAll: boolean = false): Observable<any> {
    let httpParams = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString())
    .set('filters', JSON.stringify(params || {}))
    if (offset !== undefined && offset !== null) {
      httpParams = httpParams.set('offset', offset.toString());
    }
    if (sorting !== undefined && sorting !== null) {
      httpParams = httpParams.set('sorting', sorting.toString());
    }
    // .set('offset', offset.toString())
    // .set('sorting', sorting.toString());
    // if (params) {
    //   Object.keys(params).forEach(key => {
    //     if (params[key]) {
    //       httpParams = httpParams.set(key, params[key]);
    //     }
    //   });
    // }
    if(page_name){
       httpParams = httpParams.set('page_name', page_name); 
    }
    if (searchTerm && searchTerm.trim() !== '') {
      httpParams = httpParams.set('searchTerm', searchTerm.trim()); 
    }
    if (fetchAll) {
      httpParams = httpParams.set('fetch_all', '1');
    }
    return this.http.get<any>(`${this.hostURL}/ledgers`,{ params: httpParams });
  }
  saveLedger(data: any): Observable<any> {
    const payload = JSON.stringify({ data });
    const url = `${this.hostURL}/ledgers`;
    return this.http.post(url, data);
  }
  deleteLedger(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/ledgers/${id}`);
  }
  updateLedger(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/ledgers/${id}`, data);
  }
  getledgerById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/ledgers/${id}`);
  }
  getAllLedgerAndMaps(voucherType: string, side: string, fromBranch?: any): Observable<any> {
    const url = `${this.hostURL}/ledgers`;
    let params = new HttpParams()
      .set('voucher_id', voucherType)
      .set('side', side);
    if (fromBranch) {
      params = params.set('frombranch', fromBranch);
    }
    return this.http.get<any>(url, { params });
  }
  getAllLedgerAndMapss(voucherType: string, side: string,toBranch?: any): Observable<any> {
    const url = `${this.hostURL}/ledgers`;
    let params = new HttpParams()
      .set('voucher_id', voucherType)
      .set('side', side);
    if (toBranch) {
      params = params.set('tobranch', toBranch);
    }
    return this.http.get<any>(url, { params });
  }
  //voucher
  getDataVoucher(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/voucher`);
  }
  updateVoucher(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/voucher/${id}`, data);
  }
  saveVoucher(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/voucher`, data);
  }
  deleteVoucher(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/voucher/${id}`);
  }
  getVoucherById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/voucher/${id}`);
  }

  //VoucherPosting

  getAllvoucherposting(startDate?: string, endDate?: string, voucherName?: string, branchId?: string): Observable<any> {
    let params = new HttpParams();
    if (startDate) {
      params = params.append('from_date', startDate);
    }
    if (endDate) {
      params = params.append('to_date', endDate);
    }
    if (voucherName) {
      params = params.append('voucher_id', voucherName);
    }
    if (branchId) {
      params = params.append('branch_id', branchId);
    }
    return this.http.get<any>(`${this.hostURL}/voucherposting`, { params });
  }

  createVoucherPosting(postData: any): Observable<any> {
    const url = `${this.hostURL}/creationvoucher`;
    return this.http.post(url, postData);
  }
  updateVoucherPosting(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/voucherposting/${id}`, data);
  }
  getvoucherPostingById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/voucherposting/${id}`);
  }
  getVoucher(voucherType: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/voucherslno`, { voucher_id: voucherType });
  }
  deleteVoucherPosting(id: number, data: any): Observable<any> {
    return this.http.delete(`${this.hostURL}/voucherposting/${id}`, {
      body: data
    });
  }
  getVoucherPostingDetails(voucher_id: number,creation_voucher_id: number,voucher_type: string): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/voucher-posting-details`, { voucher_id,creation_voucher_id,voucher_type });
  }


  //ledger-books
  getVoucherData(ledgerId: number, startdate?: string, enddate?: string) {
    let params = new HttpParams();
    if (startdate) {
      params = params.append('from_date', startdate);
    }
    if (enddate) {
      params = params.append('to_date', enddate);
    }
    return this.http.get<any>(`${this.hostURL}/ledgerdetails/${ledgerId}`, { params });
  }
  getVoucherdetails(voucherId: number) {
    return this.http.get<any>(`${this.hostURL}/voucherdetails/${voucherId}`);
  }

  getCreationVoucherdetails(voucherId: number) {
    return this.http.get<any>(`${this.hostURL}/voucherdetails/creation/${voucherId}`);
  }
  createStatementViewUrl(statementId: number, branch: any, profitCostId?: any, sectionId?: any, storeId?: any, fromDate?: string, toDate?: string, ledgerType?: any, value?: any, employeeId?: any): string {
    let url = `${this.hostURL}/statementview/${statementId}/${branch}`;
    const params: string[] = [];
    if (profitCostId) params.push(`profitCostId=${profitCostId}`);
    if (sectionId) params.push(`sectionId=${sectionId}`);
    if (storeId) params.push(`storeId=${storeId}`);

    if (fromDate) params.push(`fromDate=${fromDate}`);
    if (toDate) params.push(`toDate=${toDate}`);
    if (ledgerType) (Array.isArray(ledgerType) ? ledgerType : [ledgerType]).forEach(v => params.push(`ledgerType[]=${v}`));
    if (value) (Array.isArray(value) ? value : [value]).forEach(v => params.push(`value[]=${v}`));
    if (employeeId) (Array.isArray(employeeId) ? employeeId : [employeeId]).forEach(v => params.push(`employeeId[]=${v}`));
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return url;
  }

  getstatementview(statementId: number, branch: any, profitCostId?: any, sectionId?: any, storeId?: any, fromDate?: string, toDate?: string, ledgerType?: any, value?: any): Observable<any> {
    const url = this.createStatementViewUrl(statementId, branch, profitCostId, sectionId, storeId, fromDate, toDate, ledgerType, value);
    return this.http.get<any>(url);
  }

  //branch
  getDatabranch(params: any = {}): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/branch`, { params });
  }
  updatebranch(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/branch/${id}`, data);
  }
  savebranch(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/branch`, data);
  }
  getbranchById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/branch/${id}`);
  }
  deletebranch(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/branch/${id}`);
  }
  statementImport(data: any): Observable<any> {
    const url = `${this.hostURL}/statementImport`;
    return this.http.post(url, data);
  }
  userlogin(data: any): Observable<any> {
    const url = `${this.hostURL}/Userlogin`;
    return this.http.post(url, data);
  }
  getbranchData(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/branch`);
  }
  getImagesById(id: number, typeId: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/voucherpostingimage/${id}/${typeId}`);
  }
  deleteImage(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/voucherpostingimage/${id}`);
  }
  sendexportdata(exportdata: any) {
    return this.http.post<any>(`${this.hostURL}/statementExport`, exportdata, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  createbranchgroup(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/createbranchgroup`);
  }
  //voucherposting index//
  getAllcreationvoucher(paramsObj?:any,skipLoader: boolean = true): Observable<any> {
    let params = new HttpParams();
    // params.append("offset",offset)
    // console.log("offsetttttt",offset);
    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        if (paramsObj[key] !== null && paramsObj[key] !== undefined) {
          params = params.set(key, paramsObj[key]);
        }
      });
    }
    const httpOptions = {
      params,
      context: new HttpContext().set(SKIP_LOADER, skipLoader)
    };
    return this.http.get<any>(`${this.hostURL}/creationvoucherindex`, httpOptions);
  }

   //voucherposting posted index//
   getAllpostedvoucher(paramsObj?:any,all_data: boolean = false): Observable<any> {
    let params = new HttpParams();
    if (paramsObj) {
      Object.keys(paramsObj).forEach((key) => {
        if (paramsObj[key] !== null && paramsObj[key] !== undefined) {
          params = params.set(key, paramsObj[key]);
        }
      });
    }
    if (all_data) {
      params = params.set('all_data', '1');
    }
    return this.http.get<any>(`${this.hostURL}/postedvoucherindex`, { params });
  }
  getcreationepostdata(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/voucherpostingview/${id}`);
  }
  voucherpostingview(response: any): Observable<any> {
    const url = `${this.hostURL}/voucherpostingpreview`;
    return this.http.post(url, response);
  }
  creationVoucherPosting(response: any): Observable<any> {
    const url = `${this.hostURL}/voucherposting`;
    return this.http.post(url, response);
  }

  getUsers(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/user/`);
  }

  getApprovalUsers(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/approval/approval_users/`);
  }

  checkDomain(data: any): Observable<any> {
    const url = `${this.centralDomain}/domain`;
    return this.http.post(url, data);
  }
    //Start Vendor Master//
    getVendor(params: any={},index_page: number = 0): Observable<any> {
      // let params = new HttpParams();
      let httpParams = new HttpParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          httpParams = httpParams.set(key, params[key].toString());
        }
      });
      if (index_page) {
        httpParams = httpParams.set("index_page", "1");
      }
      return this.http.get<any>(`${this.hostURL}/vendor`, {params: httpParams});
    }
    showVendorById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/vendor/${id}`);
    }
    createVendor(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/vendor`, data);
    }
    updateVendor(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/vendor/${id}`, data);
    }
    //End Vendor Master//

    //start Category Master//
    getCategory(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/category`);
    }
    showCategoryById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/category/${id}`);
    }
    createCategory(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/category`, data);
    }
    updateCategory(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/category/${id}`, data);
    }
     deleteCategory(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/category/${id}`);
    }
    
    //Item Master Start//
    getItem(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/item`);
    }
    showItemById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/item/${id}`);
    }
    createItem(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/item`, data);
    }
    updateItem(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/item/${id}`, data);
    }
    gethsnno(selectedProductType: any ,voucher_type?: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/itemhsnno`, { sku_service_id: selectedProductType,voucher_type:voucher_type });
    }
    //Item Master End//
       //Start Gst Master//
    getUnit(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/unit`);
    }
    showUnitById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/unit/${id}`);
    }
    createUnit(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/unit`, data);
    }
    updateUnit(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/unit/${id}`, data);
    }
    deleteUnit(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/unit/${id}`);
    }
  //End Gst Master//
      //Start Gst Master//
    getGst(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/gst`);
    }
    showGstById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/gst/${id}`);
    }
    createGst(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/gst`, data);
    }
    updateGst(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/gst/${id}`, data);
    }
    //End Gst Master//

//user acl

    getAlluser(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/user/`);
    }

    getTenantuser(tenant_id: string): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/user/${tenant_id}`);
    }

    addTenantuser(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/user/add_tenant_user`, data);
    }

    getQueryParameter(name:any) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }

    updateUser(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/user/${id}`, data);
    }
    //end user aclß

    //start service master//
    getService(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/service`);
    }
    showServiceById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/service/${id}`);
    }
    createService(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/service`, data);
    }
    updateService(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/service/${id}`, data);
    }
    //End Service Master//
    exportVendorToExcel(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/vendorExport`, data);
    }
    vendorsample(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/downloadsample`, data);
    }

    importVendors(formData: FormData): Observable<any> {
   return this.http.post<any>(`${this.hostURL}/vendorImport`, formData);
    }

    vendorBranchSample(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/downloadsample/vendorbranch`, data);
    }  

    importVendorBranch(formData: FormData): Observable<any> {
    return this.http.post<any>(
      `${this.hostURL}/vendorImport/vendorbranch`,
      formData
    );
  }
   exportVendorBranchToExcel(data: any): Observable<any> {
   return this.http.post(`${this.hostURL}/vendorExport/vendorbranch`, data);
   }

    servicesample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadservicesample`, data);
    }
    exportServiceToExcel(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/serviceexport`, data);
    }
    importservice(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/serviceimport`, formData);
    }
    itemsample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloaditemsample`, data);
    }
    exportItemToExcel(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/itemexport`, data);
    }
    importitem(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/itemimport`, formData);
    }
    getitemunit(selectedProductType: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/itemunit`, { item_id: selectedProductType });
    }
    getvendordocumentno(vendor: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/vendordocument`, { vendor_id: vendor });
    }
     //Start Customer Master//
    getCustomer(params?: any): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/customer`, { params });
    }
    showCustomerById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/customer/${id}`);
    }
    createCustomer(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/customer`, data);
    }
    updateCustomer(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/customer/${id}`, data);
    }
    //End Customer Master//
    exportCustomerToExcel(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/customerExport`, data);
    }
    customerSample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadcustomersample`, data);
    }
    importCustomer(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/customerImport`, formData);
    }

    customerBranchSample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadcustomersample/customerbranch`, data);
    }   

      importCustomerBranch(formData: FormData): Observable<any> {
      return this.http.post<any>(
        `${this.hostURL}/customerImport/customerbranch`,
        formData
      );
    }

    exportCustomerBranchToExcel(data: any): Observable<any> {
   return this.http.post(`${this.hostURL}/customerExport/customerbranch`, data);
   }

    //company detials
    Companydetails(host: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/tenants/company_details/${host}`);
    }

    voucherpostingexport(exportdata: any) {
      return this.http.post<any>(`${this.hostURL}/voucherpostingExport`, exportdata, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    showInvoice(id: number, type?: string): Observable<any> {
      let params: any = {};
      if (type) {
        params.type = type;
      }
      return this.http.get<any>(`${this.hostURL}/invoicepayment/${id}`,{
         params});
    }
    createInvoicePayment(response: any): Observable<any> {
      const url = `${this.hostURL}/invoicepayment`;
      return this.http.post(url, response);
    }
    // customer Branch master//
    createBranch(customerbranch: any): Observable<any> {
      return this.http.post(`${this.hostURL}/customerbranch`, customerbranch);
    }
  getBranch(customerId: number, params?: any): Observable<any> {
  if (params) {
    return this.http.get(
      `${this.hostURL}/customerbranch/${customerId}`,
      { params }
    );
  }
  return this.http.get(
    `${this.hostURL}/customerbranch/${customerId}`
  );
}
    updateBranch(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/customerbranch/${id}`, data);
    }
    getAllCustomerBranches(params?: any): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/customerbranch`, { params });
    }

    //vendor  branch master
    createbranch(vendorbranch: any): Observable<any> {
      return this.http.post(`${this.hostURL}/vendorbranch`, vendorbranch);
    }
    getbranch(VendorId: number []): Observable<any> {
      // return this.http.post<any>(`${this.hostURL}/vendorbranch/${VendorId}`);
      return this.http.post<any>(`${this.hostURL}/showvendorbranch`, { ids: VendorId });
    }
    Updatebranch(VendorId: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/vendorbranch/${VendorId}`, data);
    }
    getAllVendorBranches(params?: any): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/vendorbranch`, { params });
    }
    //fetch invoice transactions
    getinvoiceTransaction(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/invoicetransaction/${id}`);
    }
    //pdf content
    pdfcontent(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/fetchpdf`, data);
    }
    getSection(params?: any): Observable<any> {   //get section
      return this.http.get<any>(`${this.hostURL}/section`, { params });
    }
    showSectionById(id: number): Observable<any> {    //get section by id
      return this.http.get<any>(`${this.hostURL}/section/${id}`);
    } 
    createSection(data: any): Observable<any> {   //create section
      return this.http.post(`${this.hostURL}/section`, data);
    }
    updateSection(id: number, data: any): Observable<any> {   //update section
      return this.http.post(`${this.hostURL}/section/${id}`, data);
    }
    getProfitCostLedger(id: number[],rounding_ledger=false,params:any={}): Observable<any> {    //get profit cost ledger
      const idString = id.join(',');
      return this.http.get(`${this.hostURL}/getprofitcostledger/${idString}/${rounding_ledger}`, { params });
    }
    deleteSection(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/section/${id}`);
    }
    getStore(): Observable<any> {   //get store
      return this.http.get<any>(`${this.hostURL}/store`);
    }
    showStoreById(id: number): Observable<any> {    //get Store by id
      return this.http.get<any>(`${this.hostURL}/store/${id}`);
    }
    createStore(data: any): Observable<any> {   //create Store 
      return this.http.post(`${this.hostURL}/store`, data);
    }
    updateStore(id: number, data: any): Observable<any> {   //update Store
      return this.http.post(`${this.hostURL}/store/${id}`, data);
    }
    deleteStore(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/store/${id}`);
    }
  getSku(store_id?: number,item_id?: number,extraParams: any = {}): Observable<any> {
    let params = new HttpParams();
    if (store_id !== undefined && store_id !== null) {
      params = params.set('store_id', store_id?.toString());
    }
    if (item_id !== undefined && item_id !== null) {
      params = params.set('item_id', item_id?.toString());
    }
    Object.keys(extraParams).forEach((key) => {
      if (extraParams[key] !== undefined && extraParams[key] !== null) {
        params = params.set(key, extraParams[key].toString());
      }
    });

    return this.http.get<any>(`${this.hostURL}/stockkeepingunit`, { params });
  }
    createSku(data: any): Observable<any> {       //create stock keeping unit 
      return this.http.post(`${this.hostURL}/stockkeepingunit`, data);
    }
    updateSku(id: number, data: any): Observable<any> {   //update stock keeping unit
      return this.http.post(`${this.hostURL}/stockkeepingunit/${id}`, data);
    }
    getSkuHsnNo(selectedProduct: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/skuhsnno`, { sku_id: selectedProduct });
    } 
    createRequisition(data: any): Observable<any> {       //create requisition 
      return this.http.post(`${this.hostURL}/requisition`, data);
    }
    updateRequisition(id: number, data: any): Observable<any> {   //update stock keeping unit
      return this.http.post(`${this.hostURL}/requisition/${id}`, data);
    }
    getReqNo(document_type:any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/requisitionno`, { document_type: document_type });
    }
    getRequisition(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/requisition`, { params });
    }
    getDocumentTracing(payload: any): Observable<any> {
      return this.http.post(`${this.hostURL}/document-tracing/trace`, payload);
    }
    getProductsByRequisition(ids: number[]): Observable<any> {
      // Sending requisition IDs in the request body
      return this.http.post<any>(`${this.hostURL}/requisitionbyid`, { ids });
    }
    createRfq(data: any): Observable<any> {       //create requisition 
      return this.http.post(`${this.hostURL}/rfq`, data);
    }
    getRfq(): Observable<any> {
      return this.http.get(`${this.hostURL}/rfq`);
    }
    getRfqById(rfq_id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/rfq/${rfq_id}`,);
    }
    createProfitCostCenter(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/profitcostcenter`, data);
    }

    getProfitCostCenter(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/profitcostcenter`, { params });
    }

    updateProfitCostCenter(id: number, data: any): Observable<any> {
      return this.http.put(`${this.hostURL}/profitcostcenter/${id}`, data);
    }
    
    deleteSku(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/stockkeepingunit/${id}`);
    }
    importGroups(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/groupImport`, formData);
    }
    groupsample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadgroupsample`, data);
    }
    groupExcelExport(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/groupExport`, data);
    }
    ledgersample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadledgersample`, data);
    }
    importLedgers(formData: FormData): Observable<any> { //new ledger create import
      return this.http.post<any>(`${this.hostURL}/ledgerImport`, formData);
    }
     updateLedgerExcel(formData: FormData): Observable<any> {  //existing ledger update import
      return this.http.post<any>(`${this.hostURL}/existingLedgerImport`, formData);
    }
    OpeningBalanceDate(data: any): Observable<any> {        //update ob date
      return this.http.post(`${this.hostURL}/obdate`, data);
    }
    getOpeningBalanceDate(data: any): Observable<any> {      //fetch ob date
      return this.http.post<any>(`${this.hostURL}/fetchobdate`,data);
    }

    //opening trial balance
    getopeningTrialBalance(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/openingTrialBalance`);
    }
    createQuotationReceive(data: any): Observable<any> {       //create quotation receive
      return this.http.post(`${this.hostURL}/quotationreceive`, data);
    }
    getQr(): Observable<any> {
      return this.http.get(`${this.hostURL}/quotationreceive`);
    }
    getQrById(Qr_id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/quotationreceive/${Qr_id}`,);
    }
    getQcNo(): Observable<any> {
      return this.http.get(`${this.hostURL}/qrno`);
    }
    getRfqNo(): Observable<any> {
      return this.http.get(`${this.hostURL}/rfqno`);
    }

    Rfqbyid(id:any): Observable<any> {  //get quotation-comparision-details
      return this.http.get(`${this.hostURL}/quotecomparision/${id}`);
    }
    QuoteComparision(): Observable<any> {  //get quotation-comparision
      return this.http.get(`${this.hostURL}/quotecomparision`);
    }
    createQuoteComparision(data: any): Observable<any> {  //create quotation-comparision
      return this.http.post(`${this.hostURL}/quotecomparision`, data);
    }

    getProductsByRfq(id: number): Observable<any> {  //get quotation-receive-by-rfqid
      return this.http.get<any>(`${this.hostURL}/quotereceivedetails/${id}`);
    }

    getPoNo(): Observable<any> {   //get po no
      return this.http.get(`${this.hostURL}/po_no`);
    }
    getQc(data: any): Observable<any> {   //get quotation comparision
      return this.http.post(`${this.hostURL}/quatationforpo`, data);
    }
    QuoteComparisiondetails(data: any): Observable<any> {  //create quotation-comparision-details
      return this.http.post(`${this.hostURL}/qcforpo`, data);
    }
    getPo(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/purchaseorder`, { params });//get po
    }
    createpo(data: any): Observable<any> {  //create purchase order
      return this.http.post(`${this.hostURL}/purchaseorder`, data);
    }

    getGrnNo(): Observable<any> {
      return this.http.get(`${this.hostURL}/grnno`);
    }
    createGrn(data: any): Observable<any> {       //create Grn 
      return this.http.post(`${this.hostURL}/grn`, data);
    }
    getGrn(params?:any): Observable<any> {
      return this.http.get(`${this.hostURL}/grn`,{params});
    }
    showGrnById(id: number): Observable<any> {    //get Grn by id
      return this.http.get<any>(`${this.hostURL}/grn/${id}`);
    }
    
    getQualityCheckNo(): Observable<any> {   //get Qc Number
      return this.http.get(`${this.hostURL}/qcno`);
    }
    showQualityCheckById(id: number): Observable<any> {   //get Qc by id
      return this.http.get<any>(`${this.hostURL}/qualitycheck/${id}`);
    }
    getQualityCheck(params?: any): Observable<any> {  //get Qc
      return this.http.get(`${this.hostURL}/qualitycheck`, { params });
    }
    createQualityCheck(data: any): Observable<any> {  //create Qc 
      return this.http.post(`${this.hostURL}/qualitycheck`, data);
    }
    updateQualityCheck(id: number, data: any): Observable<any> {  //update Qc
      return this.http.post(`${this.hostURL}/qualitycheck/${id}`, data);
    }
    updateRfq(id: number, data: any): Observable<any> {   //update Rfq
      return this.http.post(`${this.hostURL}/rfq/${id}`, data);
    }
    deleteRequisition(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/requisition/${id}`);
    }
    deleteRfq(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/rfq/${id}`);
    }
    // getProductsByPo(data: any): Observable<any> {  // get item of po
    //   return this.http.post<any>(`${this.hostURL}/pobyid`, data);
    // }

    getProductsByPo(po_id: number[], section_id: number[], profit_cost_id: number[]): Observable<any> {  // get item of po
      return this.http.post<any>(`${this.hostURL}/pobyid`, { po_id, section_id, profit_cost_id });
    }
    getPoItem(id: number): Observable<any> {  //fetch po item
      return this.http.get(`${this.hostURL}/fetchPoItem/${id}`);
    }
    vendorOfQc(params?: any): Observable<any> {   //get quotation comparision
      return this.http.get(`${this.hostURL}/vendorofqc`, { params });
    }
    updatepo(id: number,data: any): Observable<any> {  //create purchase order
      return this.http.post(`${this.hostURL}/purchaseorder/${id}`, data);
    }
    deletepo(id: number): Observable<any> {  //delete purchase order
      return this.http.delete(`${this.hostURL}/purchaseorder/${id}`);
    }

    getPurchaseOrderFiles(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/purchase-upload/${id}`);
    }
    
    deletePoImage(id: number, files: { id: number; name: string }[]) {
      return this.http.request('DELETE', `${this.hostURL}/purchase-upload/${id}`, {
        body: { files },
      });
    }
    // vendorOfPo(): Observable<any> {
    //   return this.http.get(`${this.hostURL}/vendorOfpo`);
    // }
    vendorOfPo(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/vendorOfpo`, {
    params
    });
    }

    getPurchase(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/poforgrn`, data);
    }
    updateGrn(id: number,data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/grn/${id}`, data);
    }
    deleteGrn(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/grn/${id}`);
    }
    deleteQualityCheck(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/qualitycheck/${id}`);
    }
    updateQuoteComparision(id: number, data: any): Observable<any> {  //create Quote Comparision
      return this.http.post(`${this.hostURL}/quotecomparision/${id}`, data);
    }
    deleteqc(data: any): Observable<any> {  //delete quotation comparision
      return this.http.post(`${this.hostURL}/quotecomparisiondelete`, data);
    }
    bulkvoucherpostingsample(option:any): Observable<any> {
      let sample_url=`${this.hostURL}`
      if(option=="voucher posting"){
        sample_url=`${this.hostURL}/voucherpostingsample`;
      }else if(option=="salary posting"){
        sample_url=`${this.hostURL}/voucherpostingsample/salary`
      }else if(option=="salary booking"){
        sample_url=`${this.hostURL}/voucherpostingsample/salarybooking`
      }
      return this.http.get<any>(`${sample_url}`);
    }
    importBulkVoucherPosting(formData: FormData,option:any): Observable<any> {
      let sample_url=`${this.hostURL}`
      if(option=="voucher posting"){
      sample_url=`${this.hostURL}/voucherpostingupload`;
      }else if(option=="salary posting"){
        sample_url=`${this.hostURL}/voucherpostingupload/salary`;
      }else if(option=="salary booking"){
        sample_url=`${this.hostURL}/voucherpostingupload/salarybooking`;
      }
      return this.http.post<any>(`${sample_url}`, formData);
    }
    getPi(data: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/puchaseVoucher`, data);
    }
    // getPiLedger(data: any): Observable<any> {
    //   return this.http.post(`${this.hostURL}/puchaseVoucher`, data);
    // }
    getInventory(): Observable<any> {
      return this.http.get(`${this.hostURL}/inventory`);
    }
    getSoNo(): Observable<any> {   //get so no
      return this.http.get(`${this.hostURL}/so_no`);
    }
    createso(data: any): Observable<any> {  //create sales order
      return this.http.post(`${this.hostURL}/salesorder`, data);
    }
    getSo(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/salesorder`, { params });//get so
    }
    getSalesOrderFiles(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/sales-upload/${id}`);
    }

    deleteSoImage(id: number, files: { id: number; name: string }[]) {
      return this.http.request('DELETE', `${this.hostURL}/sales-upload/${id}`, {
        body: { files },
      });
    }
    getGlobalItem(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/viewglobalitem`);
    }
    getGrnByVendor(data: any): Observable<any> {   //get grn by vendor id//purchase voucher
      return this.http.post(`${this.hostURL}/getgrnforpv`, data);
    }
    deleteso(id: number): Observable<any> {  //delete sales order
      return this.http.delete(`${this.hostURL}/salesorder/${id}`);
    }
    skubystore(id: number): Observable<any> {   //get Qc by id
      return this.http.get<any>(`${this.hostURL}/skuOfProfitCost/${id}`);
    }
    // getServiceBySection(id: number) :Observable<any>{  //get services by section
    // return this.http.get<any>(`${this.hostURL}/serviceOfSection/${id}`);
    // }
    getSoItem(id: number): Observable<any> {  //fetch so item
      return this.http.get(`${this.hostURL}/fetchSoItem/${id}`);
    }
    updateso(id: number,data: any): Observable<any> {  //update sales order
      return this.http.post(`${this.hostURL}/salesorder/${id}`, data);
    }
   customerOfSo(params?: any) {
  if (params) {
    return this.http.get(`${this.hostURL}/customerofso`, { params });
  }
  return this.http.get(`${this.hostURL}/customerofso`);
  }
    getSales(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/soforgsn`, data);
    }
    getGsnNo(): Observable<any> {
      return this.http.get(`${this.hostURL}/gsnno`);
    }
    getProductsBySo(so_id: number[], section_id: number[],profit_cost_id:number[]): Observable<any> {  // get item of so
      return this.http.post<any>(`${this.hostURL}/sobyid`, { so_id ,section_id,profit_cost_id});
    }
    createGsn(data: any): Observable<any> {       //create Gsn 
      return this.http.post(`${this.hostURL}/gsn`, data);
    }
    showGsnById(id: number): Observable<any> {    //get Gsn by id
      return this.http.get<any>(`${this.hostURL}/gsn/${id}`);
    }
    getGsn(params?: any): Observable<any> {
      return this.http.get(`${this.hostURL}/gsn`, { params });
    }

    updateGsn(id: number,data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/gsn/${id}`, data);
    }
    getGsnByCustomer(data: any): Observable<any> {   //get grn by customer id//sales voucher
      return this.http.post(`${this.hostURL}/getgsnforsv`, data);
    }
    getSi(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/salesVoucher`);
    }

    //Budget
    getbudgetsubgroup(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/getbudgetsubgroup/${id}`);
    }

    createbudgetledger(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/budget`, data);
    }

    getbudget(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/budget`);
    }
    createApprovalpath(data:any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/approval/approval-path-mappings`,data);
    }
    getApprovalPathMappings(id:number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/approval/approval-path-mappings/${id}`);
    }
    getApprovalpath():Observable<any> {
      return this.http.get<any>(`${this.hostURL}/approval/approval-paths`);
    }
    insertVouchermasterapproval(approval_path_id: string, voucher_id: number): Observable<any> {
      const data = {
        approval_path_id: approval_path_id,
        voucher_id: voucher_id,
      };
      return this.http.post<any>(`${this.hostURL}/approval/voucher-approval-mapping`, data);
    }
    
    getAllapprovalvoucher(): Observable<any> {
      let params = new HttpParams();
      return this.http.get<any>(`${this.hostURL}/approval/get-all-approvals`, { params });
    }

    getvoucherApprove(voucher_id: number): Observable<any> {
      const data={
        voucher_id :voucher_id,
      };
      return this.http.post<any>(`${this.hostURL}/approval/voucher-approve`, data);
  }  

  approvalStatus(voucher_id: number): Observable<any> {
    let params = new HttpParams();
      return this.http.get<any>(`${this.hostURL}/approval/get-approval-status/${voucher_id}`, { params });
    }
    getAllapproval(approval_path_id:number): Observable<any> {
      const data={
        approval_path_id :approval_path_id,
      };
      return this.http.post<any>(`${this.hostURL}/approval/get-approval`, data);
    }
    getProfitcostsubgroup(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/getprofitcostsubgroup/${id}`);
    }

    soShortClose(data:any): Observable<any> {
      return this.http.post(`${this.hostURL}/shortclose`, data);
    }  

    budgetSample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadbudgetsample`, data);
    }
    
    importBudget(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/budgetImport`, formData);
    }
    poShortClose(data:any): Observable<any> {
      return this.http.post(`${this.hostURL}/poshortclose`, data);
    }
    gsnShortClose(data:any): Observable<any> {
      return this.http.post(`${this.hostURL}/gsnshortclose`, data);
    }
    getGsnDetails(gsn_id: number[],profit_cost_id:number[],section_id:number[]): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/gsnbyid`, { gsn_id,profit_cost_id,section_id });
    }
    profitCostSample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadprofitcostsample`, data);
    }
    importProfitCost(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/profitCostImport`, formData);
    }
    getGrnDetails(grn_id: number[],section_id:number[],profit_cost_id:number[]): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/grnbyid`, { grn_id,section_id,profit_cost_id });
    }
    getRequisitions(data: any): Observable<any> {   //get quotation comparision
      return this.http.post(`${this.hostURL}/requisitionforpo`, data);
    }
    getLedgerByBranch(ids: number[]): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/branchledger`, { ids });
    }
    getCustomerVendorBranch(BranchId: number, Id: number, type: 'vendor' | 'customer'): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/vendorcustomerbranch`, { BranchId, Id, type });
    }  
    deleteVendorBranch(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/vendorbranch/${id}`);
    }  

    sendledgerBookexport(exportdata:any)
    {
      return this.http.post<any>(`${this.hostURL}/ledgerBookExport`, exportdata, {  //ledger-book export
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    
    getSkuById(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/stockkeepingunit/${id}`);
    }
     
    postVoucher(data: any): Observable<any> {   //post create voucher
      return this.http.post(`${this.hostURL}/postVoucher`,data);
    }
    
    getStoreRequisition(data:any): Observable<any> {  //store wise requisition fetch
      return this.http.post(`${this.hostURL}/storewiseReq`,data);
    }

    getProfitCostByStore(data:any): Observable<any> {  //store wise requisition fetch
      return this.http.post(`${this.hostURL}/profitcostbyStore`,data);
    }

    storesample(data: any): Observable<any> {  //store sample download
      return this.http.post(`${this.hostURL}/downloadstoresample`, data);
    }

    importstore(formData: FormData): Observable<any> {  //store import
      return this.http.post<any>(`${this.hostURL}/importstore`, formData);
    }
    gstsample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadgstsample`, data);
    }
    importGst(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/gstimport`, formData);
    }
    vendorOfGrn(): Observable<any> {
      return this.http.get(`${this.hostURL}/vendorofgrn`);
    }
    getGrnForQc(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/grnforqc`, data);
    }
    skusample(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/downloadskusample`, data);
    }
    importsku(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/skuimport`, formData);
    }

    getContact(): Observable<any> {  //get all contact person
      return this.http.get<any>(`${this.hostURL}/contact`);
    }
    createContact(data: any): Observable<any> {  //create contact person
      return this.http.post(`${this.hostURL}/contact`, data);
    }
    updateContact(id: number, data: any): Observable<any> {  //update contact person
      return this.http.post(`${this.hostURL}/contact/${id}`, data);
    }
    deleteContact(id: number): Observable<any> {  //delete contact person
      return this.http.delete(`${this.hostURL}/contact/${id}`);
    }
    vendorbranchdetails(Id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/vendorbranchdetails/${Id}`);  //specific vendorbranch details
    }
    customerbranchdetails(Id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/customerbranchdetails/${Id}`); //specific customerbranch details
    }
    deleteProfitCost(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/profitcostcenter/${id}`);
    }

     getVendorCode(): Observable<any> {   //get vendor code 
      return this.http.get(`${this.hostURL}/vendorcode`);
    }

     getVendorBranchCode(vendorid:any): Observable<any> {   //get vendor branch code 
      return this.http.get(`${this.hostURL}/vendorbranchcode/${vendorid}`);
    }

    getCustomerCode(): Observable<any> {   //get customer code 
      return this.http.get(`${this.hostURL}/customercode`);
    }

      getCustomerBranchCode(customerid:any): Observable<any> {   //get customer branch code 
      return this.http.get(`${this.hostURL}/customerbranchcode/${customerid}`);
    }

    deleteVendor(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/vendor/${id}`);
    }
    deleteCustomer(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/customer/${id}`);
    }
    getSectionLedger(id: number): Observable<any> {    //get section ledger
      return this.http.get(`${this.hostURL}/getsectionledger/${id}`);
    }
    getApprovalsForUser(): Observable<any> {
      return this.http.get(`${this.hostURL}/approval/user/approvals`);    }

    approveRequest(payload: { id: number; comments?: string }): Observable<any> {
      return this.http.post(`${this.hostURL}/approval/approve`, payload);
    }

    rejectRequest(payload: { id: number; comments: string }): Observable<any> {
      return this.http.post(`${this.hostURL}/approval/reject`, payload);
    }

    // Document related methods
    getDocuments(params?: any): Observable<any> {
      let httpParams = new HttpParams();
      if (params) {
        Object.keys(params).forEach(key => {
          if (params[key]) {
            httpParams = httpParams.append(key, params[key]);
          }
        });
      }
      return this.http.get<any>(`${this.hostURL}/document`, { params: httpParams });
    }

    getDocumentsindex(params?: any): Observable<any> {
      let httpParams = new HttpParams();
      if (params) {
        Object.keys(params).forEach(key => {
          if (params[key]) {
            httpParams = httpParams.append(key, params[key]);
          }
        });
      }
      return this.http.get<any>(`${this.hostURL}/document/dropdownIndex`, { params: httpParams });
    }

    createDocument(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/document`, data);
    }

    updateDocument(id: number, data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/document/${id}`, data);
    }

    deleteDocument(id: number): Observable<any> {
      return this.http.delete(`${this.hostURL}/document/${id}`);
    }

    // getApprovalPaths(): Observable<any> {
    //   return this.http.get<any>(`${this.hostURL}/approvalpath`);
    // }

    getServiceOfSection(data: any): Observable<any> { //get multiple section service
     return this.http.post<any>(`${this.hostURL}/serviceBySection`,data);
    }

  //  getSkuBySection(data: any): Observable<any> { //get  multiple section sku
  //   return this.http.post(`${this.hostURL}/skuOfSection`, data);
  //  }

   getSectionByProfitCost(id: number): Observable<any> {    //get section by single profit/cost
    return this.http.get(`${this.hostURL}/sectionByProfitCost/${id}`);
    }

    sectionsByProfitCost(profit_ids: any): Observable<any> {    //get section by multiple profit/cost
    return this.http.post(`${this.hostURL}/sectionsByProfitCost`,profit_ids);
    }

   getFilteredVoucherPostings(params: any) {
   return this.http.get<any>(`${this.hostURL}/filtered-voucherposting`, { params });   //get filter voucher detils in Audit report
   }

  exportVoucherAuditToExcel(data: any): Observable<any> {
   return this.http.post(`${this.hostURL}/voucherAuditExport`, data);
   }

    
     audit(data: any): Observable<any> {    //audit
    return this.http.post(`${this.hostURL}/audit`,data);
    }

    auditUpload(postData: any): Observable<any> {
      const url = `${this.hostURL}/auditupload`; 
      return this.http.post(url, postData);
    }

  //budget type
  getBudgettype(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/budgetType`);
  }
  updateBudgettype(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/budgetType/${id}`, data);
  }
  saveBudgettype(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/budgetType`, data);
  }
  deleteBudgettype(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/budgetType/${id}`);
  }
  getBudgettypeById(id: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/budgetType/${id}`);
  }
  // requisitionApprove(req_id: number): Observable<any> {
  //   return this.http.post(`${this.hostURL}/requisitionapprove`, { req_id: req_id });
  // }
  getInventorySku(data: any): Observable<any> {   //get inventory sku
      return this.http.post(`${this.hostURL}/getinventorysku`, data);
    }

   sectionsample(data: any): Observable<any> {  //section sample download
      return this.http.post(`${this.hostURL}/downloadsectionsample`, data);
    }

    importsection(formData: FormData): Observable<any> {  //store import
      return this.http.post<any>(`${this.hostURL}/importsection`, formData);
    }
  // sendForRequisition(req_id: number): Observable<any> {
  //   return this.http.post(`${this.hostURL}/sendforrequisition`, { req_id: req_id });
  // }
  sendForPo(po_id: number): Observable<any> {
    return this.http.post(`${this.hostURL}/sendforpo`, { po_id: po_id });
  }

  sendForApproval(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/approval/create-approval-entry`, data);
  }

  getApprovalTimeline(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/approval/document-approval-flow`, data);
  }


    getCategoryItem(): Observable<any> { //catagory item map index
      return this.http.get<any>(`${this.hostURL}/categoryitem`);
    }
    showCategoryItemById(id: number): Observable<any> { //catagory item map by id
      return this.http.get<any>(`${this.hostURL}/categoryitem/${id}`);
    }
    createCategoryItem(data: any): Observable<any> { //catagory item map create
      return this.http.post(`${this.hostURL}/categoryitem`, data);
    }
    updateCategoryItem(id: number, data: any): Observable<any> { //catagory item map update
      return this.http.post(`${this.hostURL}/categoryitem/${id}`, data);
    }
    deleteCategoryItem(id: number): Observable<any> { //catagory item map delete
      return this.http.delete(`${this.hostURL}/categoryitem/${id}`);
    }
    getItemDetails(item_id: any ,voucher_type?: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/itemdetails`, { sku_id: item_id,voucher_type:voucher_type });
    }
    getServiceDetails(service_id: any ,profit_cost_id:any,section_id:any,voucher_type?: any,): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/servicedetails`, { service_id: service_id,voucher_type:voucher_type,profit_cost_id:profit_cost_id,section_id:section_id });
    }
    getProfitCostByBranch(data:any): Observable<any> {  //branch wise pc/cc fetch
      return this.http.post(`${this.hostURL}/profitcostbyBranch`,data);
    }

    
//profitcost category mapping
    createProfitCostCategory(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/profitcostcategory`, data);
    }
   updateProfitCostCategory(id: number, data: any): Observable<any> {
   return this.http.post(`${this.hostURL}/profitcostcategory/${id}`, data);
   }
   deleteProfitCategory(id: number): Observable<any> { 
      return this.http.delete(`${this.hostURL}/profitcostcategory/${id}`);
    }
   getProfitCategory(params: any={}): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/profitcostcategory`, { params });
    }

    //category_budget
    getCategoryByProfitCostId(id: number): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/categorybudget/${id}`);
    }
     createCategoryBudget(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/categorybudget`, data);
    }
       getCategorybudget(data: any): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/categorybudget/get-category-budget`, data);
    }
       profitcategorysample(data: any): Observable<any> {  //profitcost category sample download
      return this.http.post(`${this.hostURL}/profitcategorysample`, data);
    }
     importprofitcategory(formData: FormData): Observable<any> {
      return this.http.post<any>(`${this.hostURL}/importprofitcategory`, formData);
    }
        getCategoryUtilization(data: any): Observable<any> {
      return this.http.post(`${this.hostURL}/getcategoryutilization`, data);
    }
  getItemByProfitCost(data: any): Observable<any> {  //Profit cost wise item in requisition
    return this.http.post(`${this.hostURL}/itembyprofitcost`, data);
  }

    fetchpoarchive(data: any): Observable<any> {  //fetch poarchive by po_id
      return this.http.post(`${this.hostURL}/purchaseorderarchive`, data);
    }

    popdfdata(data: any): Observable<any> { //po pdf content
      return this.http.post(`${this.hostURL}/fetchpopdf`, data);
    }
    popreview(exportdata: any) {  //po preview
      return this.http.post<any>(`${this.hostURL}/popreview`, exportdata, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }

      getGrnFiles(id: number): Observable<any> {
         return this.http.get<any>(`${this.hostURL}/grn-upload/${id}`);
       }
        deleteGrnImage(id: number, files: { id: number; name: string }[]) {
        return this.http.request('DELETE', `${this.hostURL}/grn-upload/${id}`, {
          body: { files },
        });
      }
      getQcFiles(id: number): Observable<any> {
         return this.http.get<any>(`${this.hostURL}/qc-upload/${id}`);
      }
        deleteQcImage(id: number, files: { id: number; name: string }[]) {
        return this.http.request('DELETE', `${this.hostURL}/qc-upload/${id}`, {
          body: { files },
        });
      }

    getVoucherFiles(id: number, typeId: number) {
      return this.http.get<any>(`${this.hostURL}/voucher-upload/${id}/${typeId}`);
      }

    deleteVoucherFile(voucherId: number, typeId: number, files: { id: number; name: string }[]) {
       return this.http.request('DELETE', `${this.hostURL}/voucher-upload/${voucherId}/${typeId}`, {
     body: { files }
    });
    }

      getContactsByType(contact_type: string) {
       return this.http.get<any>(`${this.hostURL}/contact/type/${contact_type}`);
     }

     getContactsByVendorBranch(vendor_id: any, branch_id: any): Observable<any[]> {
       return this.http.get<any[]>(`${this.hostURL}/purchaseorder/get-contacts`, {
     params: {
      vendor_id: vendor_id,
      branch_id: branch_id
    }
    });
    }
   getContactsByCustomerBranch(customer_id: any, branch_id: any): Observable<any[]> {
     return this.http.get<any[]>(`${this.hostURL}/salesorder/get-contacts`, {
    params: {
      customer_id: customer_id,
      branch_id: branch_id
    }
  });
  }

   getVendorCustomerByBranch(BranchId: number,type: any): Observable<any> {   //branch ledger wise vendor/customer branch's ledger
    return this.http.post<any>(`${this.hostURL}/vendorcustomerbybranch`, { BranchId , type});
   }
    getCategoryViewBudgets(): Observable<any> {
      return this.http.get<any>(`${this.hostURL}/getcategoryviewbudgets`);
    }

  calculateBudget(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/categorybudget/calculate`, data);
  }

  getLedgerViewBudgets(profitCostId: number): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/getledgerviewbudgets/${profitCostId}`);
  }

  ApproveStatus(profit_cost_id: number, document_type: any): Observable<any> {
  return this.http.post<any>(`${this.hostURL}/approvalstatus`, { profit_cost_id , document_type});
  }
  ledgerbybranch(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/ledgerbybranch`, data);
  }
  allowRequisition(data: any): Observable<any> { //allow creating a requisition by Pc/cc id
    return this.http.post(`${this.hostURL}/requisitionallowedbypc`, data);
  }
  getStoreByPcCc(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/profitcostcenter/get-store`, data);
  }
  getCategoryByType(type: string): Observable<any> {
     return this.http.get<any>(`${this.hostURL}/profitcostcategory/categories/${type}`);
  }
  requisitionReport(data:any): Observable<any> {  //branch and pc/cc wise requisition report
      return this.http.post(`${this.hostURL}/requisitionreport`,data);
    }
  updateQr(id: number, data: any): Observable<any> {   //update quotation receive
    return this.http.post(`${this.hostURL}/quotationreceive/${id}`, data);
  }
  ProfitCostOfRequisition(data:any): Observable<any> {  //requisition pc/cc show by branch_id
      return this.http.post(`${this.hostURL}/requisitionProfitcost`,data);
  }
  getCompanyHsnSac(details:any): Observable<any> { //get Company Hsn Sac
    // return this.http.get<any>(`${this.hostURL}/companyhsnsac`);
    return this.http.post(`${this.hostURL}/companyhsnsac`, details);
  }
   automation(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/automation`, data);
  }
  getHsnSacBySection(data: any): Observable<any> { //get  multiple section's Hsn Sac
    return this.http.post(`${this.hostURL}/hsnsacbypcsection`, data);
  }
  exportRequisitionReport(data: any) {  // requisition report export
      return this.http.post(`${this.hostURL}/requisitionexport/export`, data);
   }

 saveProfitCostComment(id: number, selected: {id:number, label:string}[]) {
  return this.http.post(`${this.hostURL}/saveprofitcost-comment`, { id, selected });
}
  getProfitCostComment(id: number) {
  return this.http.get(`${this.hostURL}/getprofitcost-comment/${id}`);
}
  showSkuByItemId(postData: any): Observable<any> {
    return this.http.post(`${this.hostURL}/skubyitemid`,postData);
  }
  automationGroupLedger(data: any): Observable<any> {   //all group and ledger using automation in pc/cc for category type service 
    return this.http.post(`${this.hostURL}/automationgroupledger`, data);
  }
  automationIncomeGroupLedger(data: any): Observable<any> {  //automation group and ledger for income
    return this.http.post(`${this.hostURL}/automationincomegroupledger`, data);
  }
  getEmployeelist(): Observable<any> {
  return this.http.get<any>(`${this.hostURL}/emplist`);
  }
  getAllEmployeeMasterList(): Observable<any> {
    return this.http.get<any>(`${this.hostURL}/all-employee-master-list`);   //all employee list of papl
  }
  exportPo(data: any): Observable<any> {  // purchase order export
      return this.http.post(`${this.hostURL}/purchaseorderexport/export`, data);
   }
  exportRequisition(data: any) {  // requisition export
      return this.http.post(`${this.hostURL}/requisitionlistexport/export`, data);
  }
  getFaTemplate(index_page?: number): Observable<any> {   
    //get fixed assets template
    let params = new HttpParams();
    params = params.set('index_page', index_page);
    // alert(index_page);
    return this.http.get<any>(`${this.hostURL}/fixedassetstemplate`, { params });
  }
  createFaTemplate(data: any): Observable<any> {  //create fixed assets template 
    return this.http.post(`${this.hostURL}/fixedassetstemplate`, data);
  }
  updateFaTemplate(id: number, data: any): Observable<any> {   //update fixed assets template
    return this.http.post(`${this.hostURL}/fixedassetstemplate/${id}`, data);
  }
  getCompanyActCategory(): Observable<any> {   //get company act categories
    return this.http.get<any>(`${this.hostURL}/companyactcategory`);
  }
  createCompanyActCategory(data: any): Observable<any> {  //create company act category
    return this.http.post(`${this.hostURL}/companyactcategory`, data);
  }
  updateCompanyActCategory(id: number, data: any): Observable<any> {   //update company act category
    return this.http.post(`${this.hostURL}/companyactcategory/${id}`, data);
  }
  getItActCategory(): Observable<any> {   //get It act categories
    return this.http.get<any>(`${this.hostURL}/itactcategory`);
  }
  createItActCategory(data: any): Observable<any> {  //create It act category
    return this.http.post(`${this.hostURL}/itactcategory`, data);
  }
  updateItActCategory(id: number, data: any): Observable<any> {   //update It act category
    return this.http.post(`${this.hostURL}/itactcategory/${id}`, data);
  }
  getDepreciationMethod(): Observable<any> {   //get depreciation method
    return this.http.get<any>(`${this.hostURL}/depreciationmethod`);
  }
  createDepreciationMethod(data: any): Observable<any> {  //create depreciation method
    return this.http.post(`${this.hostURL}/depreciationmethod`, data);
  }
  updateDepreciationMethod(id: number, data: any): Observable<any> {   //update depreciation method
    return this.http.post(`${this.hostURL}/depreciationmethod/${id}`, data);
  }

  rfqByVendor(vendorId: number): Observable<any> {  //rqf by vendor_id
    return this.http.get<any>(`${this.hostURL}/rfqdata/${vendorId}`);
  }
  vendorbranchByrfq(data: any): Observable<any> {  //vendor branch by rfq_id
    return this.http.post(`${this.hostURL}/vendorbranchbyrfq`, data);
  }
  rfqDetails(rfqId: number): Observable<any> { //rfq_id wise detqils
    return this.http.get<any>(`${this.hostURL}/rfqdetails/${rfqId}`);
  }
  getProfitSectionByPo(data: any): Observable<any> {   //  pc/cc sectiion by po
    return this.http.post(`${this.hostURL}/ProfitSectionByPo`, data);
  }
  getFaMaster(): Observable<any> {   //get Fa master
    return this.http.get<any>(`${this.hostURL}/fixedassetsmaster`);
  }
  createFaMaster(data: any): Observable<any> {  //create fa master
    return this.http.post(`${this.hostURL}/fixedassetsmaster`, data);
  }
  getProfitSectionByGrn(data: any): Observable<any> {   //  pc/cc sectiion by grn
    return this.http.post(`${this.hostURL}/ProfitSectionByGrn`, data);
  }
  getBranchBySo(data: any): Observable<any> {   //get branch,pc cc,section by so id
    return this.http.post(`${this.hostURL}/getbranchbyso`, data);
  }
  getGsnFiles(id: number): Observable<any> {  //get gsn image 
    return this.http.get<any>(`${this.hostURL}/gsn-upload/${id}`);
  }
  deleteGsnImage(id: number, files: { id: number; name: string }[]) { //delete gsn image
    return this.http.request('DELETE', `${this.hostURL}/gsn-upload/${id}`, {
      body: { files },
    });
  }
  GrnById(id: number,section_id:any,profit_cost_id:any): Observable<any> {    //get Grn by id in qc
    return this.http.get<any>(`${this.hostURL}/qcgrnbyid/${id}/${section_id}/${profit_cost_id}`);
  }

  previewCarryForwardBatch(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/categorybudget/preview-carry-forward-batch`, data);
  }

  applyCarryForwardBatch(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/categorybudget/apply-carry-forward-batch`, data);
  }

  getRequisitionsByFilters(postData: any): Observable<any> {
    return this.http.post(`${this.hostURL}/requisitions/reqby-branch-profit-section`, postData);
  }
  
  deleteGsn(id: number, data: any): Observable<any> {
    return this.http.delete(`${this.hostURL}/gsn/${id}`, {
      body: data
    });
  }

  requisitionForEdit(id: number): Observable<any> {    //requisition for edit
    return this.http.get<any>(`${this.hostURL}/requisitionforedit/${id}`);
  }

   showSpecification(postData: any): Observable<any> {
    return this.http.post(`${this.hostURL}/getspecification`,postData);
  }
  deleteVoucherPostingimage(imageId: number) {
  return this.http.delete(`${this.hostURL}/voucherpostingimage/${imageId}`);
  }

  duplicateVoucher(payload: any) {  // voucher duplicate
  return this.http.post(`${this.hostURL}/duplicateVoucher`, payload);
  }
  
  PostedVoucherdetails(payload: any) {   //posted voucher detsils fetch
    return this.http.post<any>(`${this.hostURL}/voucherdetails/posted`, payload);
  }

  createSkuItemMapping(data: any): Observable<any> {       //create stock keeping unit item mapping 
    return this.http.post(`${this.hostURL}/sku-mapping`, data);
  }
  
  getMappedSkuByItem(itemId: number) {
    return this.http.get<any>(
      `${this.hostURL}/sku-mapping/item/${itemId}`
    );
  }

  checkNextDocument(postData: any): Observable<any> {
    return this.http.post(`${this.hostURL}/approval/check-next-document`, postData);
  }

  cancelApproval(postData: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/approval/cancel_approval`, postData);
  }

  getitemWisereport(filters: any): Observable<any> {
    return this.http.post(
      `${this.hostURL}/report/item-wise-report`,
      filters
    );
  }

  exportItemwiseExcel(filters: any): Observable<any> {
      return this.http.post(`${this.hostURL}/itemwise-export`, filters);
  }

  lineItemSample(document_type: string): Observable<any> {
    return this.http.get(`${this.hostURL}/download_line_item_sample/${document_type}`);
  }
  lineItemImport(formData: FormData): Observable<any> {
    return this.http.post(`${this.hostURL}/import_line_item`, formData);
  }
  downloadlog(userId: number, date: string) {
    return this.http.get(`${this.hostURL}/changelog/download`, {
      params: { user_id: userId.toString(), date },
    });
  }
    getVendorBranchLedger(postData: any): Observable<any> { //branch wise vendor branch ledger
    return this.http.post<any>(`${this.hostURL}/vendorbranchledger`, postData);
  }
    getCustomerBranchLedger(postData: any): Observable<any> { //branch wise customer branch ledger
    return this.http.post<any>(`${this.hostURL}/customerbranchledger`, postData);
  }
  ProfitCostByInvoiceId(data: any): Observable<any> { //profit cost by specific invoice
    return this.http.post<any>(`${this.hostURL}/profitcostbyinvoiceid`, data);
  }
  getLedgerType(): Observable<any> {   //get ledger type
    return this.http.get<any>(`${this.hostURL}/ledger-type`);
  }
  // showLedgerTypeById(id: number): Observable<any> {    //get ledger type by id
  //   return this.http.get<any>(`${this.hostURL}/ledger-type/${id}`);
  // }
  createLedgerType(data: any): Observable<any> {   //create ledger type 
    return this.http.post(`${this.hostURL}/ledger-type`, data);
  }
  updateLedgerType(id: number, data: any): Observable<any> {   //update ledger type
    return this.http.post(`${this.hostURL}/ledger-type/${id}`, data);
  }
  deleteLedgerType(id: number): Observable<any> {
    return this.http.delete(`${this.hostURL}/ledger-type/${id}`);
  }
  allowItemForRequisitionSo(data: any): Observable<any> { //block unblock item for creating a requisition and so 
    return this.http.post(`${this.hostURL}/requisition-so-allowed-by-item`, data);
  }

  toggleProfitCostActive(data: any) :Observable<any>{
  return this.http.post( `${this.hostURL}/profitcost-active`, data);
  }
  groupbystatement(postData: any): Observable<any> {   //get group data by statement
    return this.http.post<any>(`${this.hostURL}/groupbystatement`, postData);
  }
  getsubgroupData(postData: any): Observable<any> {   //get subgroup data
    return this.http.post<any>(`${this.hostURL}/subgroup`, postData);
  }
  getledgerpath(): Observable<any> {   //get ledger path data
    return this.http.get<any>(`${this.hostURL}/ledger-path`);
  }
  createLedgerPath(data: any): Observable<any> {   //create ledger path 
    return this.http.post(`${this.hostURL}/ledger-path`, data);
  }
  updateLedgerPath(id: number, data: any): Observable<any> {   //update ledger path
    return this.http.post(`${this.hostURL}/ledger-path/${id}`, data);
  }
  showLedgerPath(id: number): Observable<any> { //show ledger path by id
    return this.http.get<any>(`${this.hostURL}/ledger-path/${id}`);
  }
  obdetailsSample(data: any): Observable<any> { //ob_details sample
    return this.http.post(`${this.hostURL}/obdetailsample`, data);
  }
  obdetailsImport(formData: FormData): Observable<any> { //bulk import of ledger_ob_details
    return this.http.post<any>(`${this.hostURL}/obdetailsimport`, formData);
  }
   salarydetailsSample(data: any): Observable<any> { //salary_ob_details sample
    return this.http.post(`${this.hostURL}/salaryobdetailsample`, data);
  }
  salarydetailsImport(formData: FormData): Observable<any> { //bulk import of salary_ob_details
    return this.http.post<any>(`${this.hostURL}/salaryobdetailsimport`, formData);
  }
  getCreationVoucherIds(vendorBranchId: number, type: string): Observable<any> {  //get creation voucher ids for a vendor branch
  return this.http.post(`${this.hostURL}/get-creation-voucher-ids`,{ type_id:vendorBranchId, type: type });
  }
  getVoucherBreakdownByIds( creationVoucherIds: number[],ledgerId: number):Observable<any> {
  return this.http.post(`${this.hostURL}/get-voucher-breakdown-by-ids`,{creation_voucher_ids:creationVoucherIds,ledger_id:ledgerId});
  }
  getVoucherBookDetails(creationVoucherId: number): Observable<any> {
  return this.http.get(`${this.hostURL}/voucher-book-details/${creationVoucherId}`);
}
  getVoucherDetailsByProfitCenter(payload: any) {
    return this.http.post<any>(`${this.hostURL}/voucherdetails/posted-by-profit-center`, payload);
  }
  createSalesPurchaseReturn(data: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/sales-purchase-return`, data);
  }
  getSalesPurchaseReturns(data?: any) {
    return this.http.get<any>(`${this.hostURL}/sales-purchase-return`, data);
  }
  getSalesPurchaseReturnById(id: any) {
    return this.http.get<any>(`${this.hostURL}/sales-purchase-return/${id}`);
  }
  updateSalesPurchaseReturn(id: any, data: any) {
    return this.http.post<any>(`${this.hostURL}/sales-purchase-return/${id}`, data);
  }
  getDocumentData(data: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/fetchdocument`, data);
  }
  documentDataDetails(data: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/fetchdocumentdetail`, data);
  }
  itemDetails(data: any): Observable<any> {
    return this.http.post<any>(`${this.hostURL}/itemlist`, data);
  }

  getBranchByPo(data: any): Observable<any> {   //get branch,pc cc,section by po id
    return this.http.post(`${this.hostURL}/getbranchbypo`, data);
  }

  getProfitCostBudgetPeriod(data: any): Observable<any> {  // sales order start date and  end date by profit center
    return this.http.post(`${this.hostURL}/categorybudget/get-profit-cost-budget-period`, data);
  }
  getMaxDates(profitCostId: number,type:string): Observable<any> {  // po latest expected delivery date and sales order end date  and buffer days  by profit center
    return this.http.get(`${this.hostURL}/profitcostcenter/${profitCostId}/max-dates?type=${type}`);
  }
  validateRequisitionDate(data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/requisition/validate-date`, data);
  }
  saveBufferDays(id: number, data: any): Observable<any> {
    return this.http.post(`${this.hostURL}/profitcostcenter/${id}/buffer-days`, data);
  }

}

